import { forwardRef, type Ref, type SVGProps } from "react";
const IconArrowLeftFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M15.62 24.39a2 2 0 0 0 0-2.94L12 18h13a2 2 0 0 0 0-4H12l3.62-3.45a2 2 0 0 0 0-2.94 2.16 2.16 0 0 0-3 0l-7 6.86a2.2 2.2 0 0 0 0 3.06l7 6.86a2.16 2.16 0 0 0 3 0" />
  </svg>
);
const ForwardRef = forwardRef(IconArrowLeftFilledSVG);
ForwardRef.displayName = "IconArrowLeftFilled";
export { ForwardRef as IconArrowLeftFilled };
